
import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { Page404Component } from './pages/404/404.component';
import { ConsulterComponent } from './pages/consulter/consulter.component';
import { SeancesComponent } from './pages/seances/seances.component';
import { AproposComponent } from './pages/apropos/apropos.component';
import { ContactComponent } from './pages/contact/contact.component';

export const AppRoutes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full'},
  { path: 'home', component: HomeComponent },
  { path: 'consulter', component: ConsulterComponent },
  { path: 'seances', component: SeancesComponent },
  { path: 'apropos', component: AproposComponent },
  { path: 'contact', component: ContactComponent },
  { path: '404', component: Page404Component},
  { path: '**', redirectTo: '/404' }
];



// WEBPACK FOOTER //
// /Users/enzo/Desktop/capsycofr-angular/src/app/app.routes.ts